module.exports = __webpack_public_path__ + "static/media/right-arrow.1d292928.svg";